import React, { memo } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {
  LDP_METRICS_OTHER_PAGE,
  LDP_METRICS_PHONE_CALL_ACTION,
  LDP_METRICS_PHONE_HOVER_ACTION,
  LDP_METRICS_PROFILE_PAGE,
  LDP_METRICS_RETAILER_CLASSNAME,
  LDP_METRICS_STORE_CLASSNAME,
  LDP_METRICS_STORE_LOCATOR_PAGE,
  LDP_METRICS_TRY_THIS_BED_PAGE,
} from "../constants";

import {ldpMetricsAction} from "../utils";
import DataLayerService from "datalayer-service/src/datalayer";
import {CTAClickCategory, CTAClickLevel, CTAClickSubcategory} from "datalayer-service/src/types/enums";

const dataLayerService = new DataLayerService(window);

export const IS_MOBILE = 992;
export const ID = 'phone-btn';

class PhoneButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasBeenHovered: false,
      elapsedHoverTime: 0,
      screenWidth: 0,
    };

    this.isMobile = this.isMobile.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.ldpMetrics = this.ldpMetrics.bind(this);
  }

  componentDidMount() {
    const isClient = typeof document === 'object';

    if (isClient) {
      this.setState({screenWidth: document.body.clientWidth});
    }
  }

  isMobile() {
    const {screenWidth} = this.state;

    return screenWidth <= IS_MOBILE;
  }

  ldpMetrics(action) {
    const {locationPage, storeSlug, isLDP, objectClassname} = this.props;

    if (isLDP && action) {
      ldpMetricsAction(locationPage, action, storeSlug, objectClassname);
    }
  }

  handleClick() {
    this.ldpMetrics(LDP_METRICS_PHONE_CALL_ACTION);

    const eventData = this.getCTAEventData(CTAClickSubcategory.PHONE_NUMBER_CLICKED);
    dataLayerService.CTAClickEvent(eventData);
  }

  isMobile() {
    const {screenWidth} = this.state;

    return screenWidth <= IS_MOBILE;
  }

  getCTAEventData(eventSubCategory) {
    const {pageRegion, retailerSlug, storeSlug, retailerName, isLDP} = this.props;

    return {
      category: CTAClickCategory.CALL_STORE,
      subcategory: eventSubCategory,
      level: CTAClickLevel.SECONDARY,
      pageRegion: pageRegion,
      store: {
        isLDP: isLDP,
        retailerLocation: storeSlug || retailerSlug || "",
        retailerName: retailerName,
      }
    };

  }

  handleMouseEnter() {
    this.setState({elapsedHoverTime: Date.now()});
  }

  handleMouseLeave() {
    const {hasBeenHovered, elapsedHoverTime} = this.state;

    if (elapsedHoverTime && Date.now() - elapsedHoverTime > 500) {
      this.ldpMetrics(!hasBeenHovered && !this.isMobile() ? LDP_METRICS_PHONE_HOVER_ACTION : undefined);

      dataLayerService.CTAClickEvent(this.getCTAEventData(CTAClickSubcategory.PHONE_HOVER));
      this.setState({hasBeenHovered: true});
    }
    this.setState({elapsedHoverTime: 0});
  }

  render() {
    const {className, storeName, phone, showText} = this.props;
    const {hasBeenHovered} = this.state;

    return (
      <a
        className={`btn store-phone-call-btn ${className}`}
        href={`tel://${phone}`}
        aria-label={`Call ${storeName}`}
        target="_self"
        onClick={this.handleClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <i className="fa fa-phone"/>
        {showText && <b>{hasBeenHovered ? phone : "Call Store"}</b>}
      </a>
    );
  }
}

PhoneButton.propTypes = {
  className: PropTypes.string,
  storeSlug: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
  retailerName: PropTypes.string.isRequired,
  retailerSlug: PropTypes.string,
  phone: PropTypes.string.isRequired,
  locationPage: PropTypes.oneOf([
    LDP_METRICS_STORE_LOCATOR_PAGE,
    LDP_METRICS_TRY_THIS_BED_PAGE,
    LDP_METRICS_OTHER_PAGE,
    LDP_METRICS_PROFILE_PAGE,
  ]).isRequired,
  objectClassname: PropTypes.oneOf([
    LDP_METRICS_STORE_CLASSNAME,
    LDP_METRICS_RETAILER_CLASSNAME,
  ]),
  isLDP: PropTypes.bool,
  showText: PropTypes.bool,
  pageRegion: PropTypes.string
};

PhoneButton.defaultProps = {
  className: "gray-btn",
  objectClassname: LDP_METRICS_STORE_CLASSNAME,
  isLDP: false,
  showText: true,
};

export default memo(PhoneButton);

export function renderPhoneButton(selector = `[id=${ID}]`) {

  for (let element of document.querySelectorAll(selector)) {
    const className = element.getAttribute("data-classname");
    const storeSlug = element.getAttribute("data-store-slug");
    const storeName = element.getAttribute("data-store-name");
    const retailerName = element.getAttribute("data-retailer-name") || storeName;
    const retailerSlug = element.getAttribute("data-retailer-slug") || storeSlug;
    const phone = element.getAttribute("data-phone");
    const locationPage = element.getAttribute("data-location-page");
    const objectClassname = element.getAttribute("data-object-classname");
    const isLDP = element.getAttribute("data-ldp");
    const showText = element.getAttribute("data-show-text");
    const pageRegion = element.getAttribute("data-page-region");


    ReactDOM.render(
      <PhoneButton
        className={className || "gray-btn"}
        storeSlug={storeSlug}
        storeName={storeName}
        retailerName={retailerName}
        retailerSlug={retailerSlug}
        phone={phone}
        locationPage={locationPage}
        objectClassname={objectClassname || LDP_METRICS_STORE_CLASSNAME}
        isLDP={isLDP === "True" || isLDP === "true" || isLDP === "1"}
        showText={showText ? showText === "true" : false}
        pageRegion={pageRegion}
      />,
      element
    );

  }
}
